package compose.assets

import androidx.compose.ui.graphics.vector.ImageVector
import compose.assets.svg.ArrowLeft
import compose.assets.svg.Bsoft
import compose.assets.svg.CalendarRangeOutline
import compose.assets.svg.CampaignOutline
import compose.assets.svg.CardAccountDetailsOutline
import compose.assets.svg.ChatProcessingOutline
import compose.assets.svg.Check
import compose.assets.svg.CheckCircle
import compose.assets.svg.ChevronRight
import compose.assets.svg.ClockOutline
import compose.assets.svg.ClockTimeFour
import compose.assets.svg.CloseOutline
import compose.assets.svg.ContentSaveOutline
import compose.assets.svg.DeleteOutline
import compose.assets.svg.DeviceOutline
import compose.assets.svg.DisplayHorizontalOutline
import compose.assets.svg.DisplayVerticalOutline
import compose.assets.svg.DownloadOutline
import compose.assets.svg.EditOutline
import compose.assets.svg.EyeOffOutline
import compose.assets.svg.EyeOutline
import compose.assets.svg.GridOutline
import compose.assets.svg.HelpCircleOutline
import compose.assets.svg.ImageAddOutline
import compose.assets.svg.ImageOutline
import compose.assets.svg.LayersOutline
import compose.assets.svg.ListBoxOutline
import compose.assets.svg.LocationOutline
import compose.assets.svg.LogoutOutline
import compose.assets.svg.MediaOutline
import compose.assets.svg.Moon
import compose.assets.svg.OverscanOutline
import compose.assets.svg.PauseCircle
import compose.assets.svg.PencilCircle
import compose.assets.svg.Play
import compose.assets.svg.PlayCircle
import compose.assets.svg.Plus
import compose.assets.svg.RelativeScaleOutline
import compose.assets.svg.ResetOutline
import compose.assets.svg.RotateOutline
import compose.assets.svg.Search
import compose.assets.svg.ShieldAccountVariantOutline
import compose.assets.svg.Sparkle
import compose.assets.svg.Sun
import compose.assets.svg.TrashOutline
import compose.assets.svg.UploadOutline
import compose.assets.svg.UserOutline
import compose.assets.svg.VideoOutline
import kotlin.collections.List as ____KtList

public object Svg

private var __All: ____KtList<ImageVector>? = null

public val Svg.All: ____KtList<ImageVector>
  get() {
    if (__All != null) {
      return __All!!
    }
    __All= listOf(EyeOffOutline, CampaignOutline, GridOutline, CalendarRangeOutline, ClockOutline,
        LayersOutline, ResetOutline, Bsoft, Check, Plus, Search, ClockTimeFour, VideoOutline,
        ImageOutline, EyeOutline, UserOutline, ShieldAccountVariantOutline, PlayCircle, Sparkle,
        DisplayVerticalOutline, LocationOutline, UploadOutline, TrashOutline, Play,
        RelativeScaleOutline, ImageAddOutline, DisplayHorizontalOutline, DownloadOutline,
        MediaOutline, DeleteOutline, DeviceOutline, ChevronRight, Sun, ListBoxOutline, ArrowLeft,
        OverscanOutline, CloseOutline, ChatProcessingOutline, Moon, RotateOutline, PauseCircle,
        EditOutline, CheckCircle, CardAccountDetailsOutline, PencilCircle, HelpCircleOutline,
        LogoutOutline, ContentSaveOutline)
    return __All!!
  }
